export default {"src":"/_next/static/media/phone-icon.c74a6db2.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};